<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/extendCommonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "parkuuids": [
                "6ca5826b-fbfe-4372-a940-5db99c9d67b2"
              ]
            },
            responseCode: {
                "data": {
                    "time": "",
                    "roadUseRate": "",
                    "nonoadUseRate": "",
                    "totalUseRate": ""
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "通过此接口可传递车场列表获取路内外车位使用率",
                t_url: this.commonUrls.test+"extend/getParkSpace",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkuuids', info2: '是', info3: 'JSONArray', info4: '车场UUID列表' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'time', info2: '是', info3: 'String', info4: '时间' },
                        { info1: 'roadUseRate', info2: '是', info3: 'String', info4: '路边车位使用率' },
                        { info1: 'nonoadUseRate', info2: '是', info3: 'String', info4: '路内车位使用率' },
                        { info1: 'totalUseRate', info2: '是', info3: 'String', info4: '总计使用率' }
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/other/getParkSpace.vue